export type FooterProps = {
  onDelete?: () => void
  onSubmit: () => Promise<void>
  onCancel: () => void
  isSaving: boolean
}
